// extracted by mini-css-extract-plugin
export var current = "pagination-module--current--bb883";
export var dots = "pagination-module--dots--84ce6";
export var pagination = "pagination-module--pagination--e5f14";
export var paginationNumbers = "pagination-module--paginationNumbers--aa579";